import React from 'react';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';

interface DeleteUserConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const DeleteUserConfirmModal: React.FC<DeleteUserConfirmModalProps> = ({ isOpen, onClose, onConfirm }) => {
    const { t } = useTranslation('users');
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 items-center z-50">
            <div className="bg-white my-[15%] mx-auto w-4/5 max-w-lg p-5 border-[#888] rounded text-center text-black">
                <h2>{t('user delete confirmation')}</h2>
                <p>{t('do you want to delete this user')}</p>
                <div className='flex flex-row justify-center'>
                    <div className='m-[10px]'>
                        <Button
                            label={t('delete')}
                            onClick={onConfirm}
                        />
                    </div>
                    <div className='m-[10px]'>
                        <Button
                            label={t('back')}
                            onClick={onClose}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteUserConfirmModal;